import type { UseMutationProps } from '../useMutation/index'
import { useMutation } from '../useMutation/index'
import { gql } from '@apollo/client'

const defaultQuery = gql`
  mutation createManyFile($input: JSON!) {
    createManyFile(input: $input) {
      ok
    }
  }
`

export const useCreateManyFile = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? defaultQuery

  return useMutation({ query, ...props })
}
